module.exports = __webpack_public_path__ + "../resources/images/illustration_search_file-9e0718d2c031bc39cb6c8f94123c8cab.svg";